<template>
	<div>
		<el-card>
			<div slot="header" style="display: inline-block;float: left;font-weight: bolder;font-size: 24px;">
				{{$t('lang.lab_xlDeviceManege')}}</div>
			<el-button type="primary" slot="header" @click="back">返回电梯设备管理</el-button>
			<el-button type="primary" slot="header" @click="add">{{$t('lang.lab_addXlDevice')}}</el-button>
			<!-- 子门禁表格 -->
			<el-table :data="list" class="wid100" :height="list.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="xlDeviceNum" :label="$t('lang.lab_xlDeviceNum')"></el-table-column>
				<el-table-column prop="xlDeviceName" :label="$t('lang.lab_xlDeviceName')"></el-table-column>
				<el-table-column prop="createTime" :label="$t('lang.lab_ctDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.createTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operTime" :label="$t('lang.lab_otDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.operTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150px">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<el-button class="orange" @click="del(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 添加子门禁dialog -->
		<el-dialog :title="$t('lang.lab_addXlDevice')" :visible.sync="addDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="liftDeviceSonForm" :rules="rules" ref="liftDeviceSonForm">
				<el-form-item :label="$t('lang.lab_numDoorDeviceSon')" label-width="120px" prop="xlDeviceNum">
					<el-input v-model="liftDeviceSonForm.xlDeviceNum" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="设备名称" label-width="120px" prop="xlDeviceName">
					<el-input v-model="liftDeviceSonForm.xlDeviceName" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addDoorDeviceSon(liftDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
		<!-- 修改子门禁dialog -->
		<el-dialog :title="$t('lang.lab_editDoorDeviceSon')" :visible.sync="editDialogFormVisible"
			:close-on-click-modal="false" center top="130px" width="600px">
			<el-form :model="liftDeviceSonForm" :rules="rules" ref="liftDeviceSonForm">
				<el-form-item :label="$t('lang.lab_numDoorDeviceSon')" label-width="120px" prop="xlDeviceNum">
					<el-input v-model="liftDeviceSonForm.xlDeviceNum" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="设备名称" label-width="120px" prop="xlDeviceName">
					<el-input v-model="liftDeviceSonForm.xlDeviceName" autocomplete="off"></el-input>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editDoorDeviceSon(liftDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lifeDeviceId: '',
				list: [],

				addDialogFormVisible: false,
				liftDeviceSonForm: {
					id: '',
					xlDeviceName: '',
					xlDeviceNum: ''
				},

				editDialogFormVisible: false,

				rules: {
					xlDeviceName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_xlDeviceName'),
						trigger: 'blur'
					}],
					xlDeviceNum: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_xlDeviceNum'),
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.lifeDeviceId = this.$route.query.id
			this.selectList()
		},
		methods: {
			back() {
				this.$router.push({
					name: 'elevBluetoothEquipManagesList'
				})
			},
			selectList() {
				let loading = this.$loading()
				this.$get(`/xl/device/lift/list?deviceId=` + this.lifeDeviceId + `&pageNo=1&pageSize=99`)
					.then(response => {
						// console.log(response);
						this.list = response.list
						loading.close()
					})
					.catch(error => {
						console.log(error)
					})
			},
			add() {
				this.addDialogFormVisible = true
				this.liftDeviceSonForm.xlDeviceName = ''
				this.liftDeviceSonForm.xlDeviceNum = ''
			},
			addDoorDeviceSon(liftDeviceSonForm) {
				this.$refs.liftDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							deviceId: this.lifeDeviceId,
							xlDeviceName: liftDeviceSonForm.xlDeviceName,
							xlDeviceNum: liftDeviceSonForm.xlDeviceNum
						}
						this.$post(`/xl/device/lift/add`, param)
							.then(response => {
								// console.log(response);
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								loading.close()
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editDialogFormVisible = true
				this.liftDeviceSonForm.id = row.id
				this.liftDeviceSonForm.xlDeviceName = row.xlDeviceName
				this.liftDeviceSonForm.xlDeviceNum = row.xlDeviceNum
				// console.log(row)
			},
			editDoorDeviceSon(liftDeviceSonForm) {
				this.$refs.liftDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							deviceId: this.lifeDeviceId,
							xlDeviceName: liftDeviceSonForm.xlDeviceName,
							xlDeviceNum: liftDeviceSonForm.xlDeviceNum
						}
						this.$patch(`/xl/device/lift/modify/` + this.liftDeviceSonForm.id, param)
							.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.editDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								this.$message.error(this.$i18n.t('lang.resourEditLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				this.$confirm(
					this.$i18n.t('lang.lab_isdelete'),
					this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						cancelButtonText: this.$i18n.t('lang.btn_cancel'),
						type: 'warning'
					}
				).then(() => {
					let loading = this.$loading()
					this.$delete(`/xl/device/lift/delete/` + id)
						.then(response => {
							if (response && response.errCode === 0) {
								this.$message({
									type: 'success',
									message: this.$i18n.t('lang.lab_del_success')
								})
								this.selectList()
								loading.close()
							}
						})
						.catch(error => {
							this.$message({
								type: 'error',
								message: this.$i18n.t('lang.lab_del_fail')
							})
							loading.close()
							console.log(error)
						})
				})
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>